import { CBadge, CTooltip } from "@coreui/react";

export const CASHBACK_TOTAL_EXPLANATION =
  'Solo incluye descuentos del tipo "Reintegro", que es plata devuelta en ' +
  'efectivo al cliente. Los del tipo "Reintegro solo ticket" no entran acá: ' +
  "esos bajan el precio, así que ya están contabilizados dentro de los " +
  "descuentos.";

/**
 * Icono "i" al lado de las cifras de reintegro.
 *
 * Existe porque hay dos promociones que el vendedor llama igual y que se
 * contabilizan en lugares distintos: el reintegro puro sale del cajón y no baja
 * lo facturado, mientras que el "solo ticket" es un descuento común. Sin la
 * aclaración, un total de reintegro más bajo de lo esperado parece un error.
 */
const CashbackInfoBadge = () => {
  return (
    <CTooltip content={CASHBACK_TOTAL_EXPLANATION}>
      <CBadge shape="pill" color="info" className={"mr-1"}>
        <i className="fa fa-info icon"></i>
      </CBadge>
    </CTooltip>
  );
};

export default CashbackInfoBadge;
